import { createSelector, DuckSelector, createCachedSelector } from '@atc/modular-redux';
import { LruObjectCache } from 're-reselect';
import _get from 'lodash/get';
export default () => ({
  getLocation: new DuckSelector(selectors => state => _get(selectors.getDuckState(state), 'location')),
  getZip: new DuckSelector(selectors => state => _get(selectors.getLocation(state), 'zip')),
  getCityState: new DuckSelector(selectors => createSelector(selectors.getLocation, _ref => {
    let {
      city,
      state
    } = _ref;
    return city && state && `${city}, ${state}`;
  })),
  getPersonalizationAlert: new DuckSelector(selectors => state => _get(selectors.getDuckState(state), 'globalAlert')),
  getSavedSearchIds: new DuckSelector(selectors => state => _get(selectors.getDuckState(state), 'bookmarks.searchIds')),
  getShowEmailSubscribeInline: new DuckSelector(selectors => state => _get(selectors.getDuckState(state), 'showEmailSubscribeInline')),
  getShowEmailSubscribeModal: new DuckSelector(selectors => state => _get(selectors.getDuckState(state), 'showEmailSubscribeModal')),
  getUserProfile: new DuckSelector(selectors => state => _get(selectors.getDuckState(state), 'profile')),
  getLeadProfile: new DuckSelector(selectors => state => _get(selectors.getDuckState(state), 'leadProfile')),
  getSavedSearch: new DuckSelector(selectors => state => _get(selectors.getDuckState(state), 'bookmarks.search')),
  getSubscribedSearch: new DuckSelector(selectors => state => _get(selectors.getDuckState(state), 'bookmarks.subscribe')),
  getSavedSearchCount: new DuckSelector(selectors => createSelector(selectors.getSavedSearchIds, ids => ids.length)),
  getUpdateSavedSearchState: new DuckSelector(selectors => state => _get(selectors.getDuckState(state), 'updateSavedSearch')),
  getShowUpdateSavedSearch: new DuckSelector(selectors => state => _get(selectors.getDuckState(state), 'showUpdateSavedSearch')),
  getUserPhone: new DuckSelector(selectors => state => _get(selectors.getUserProfile(state), 'phone')),
  seoLocation: new DuckSelector(selectors => createSelector(selectors.getLocation, location => {
    if (location.city && location.state && location.zip) {
      return `${location.city}+${location.state}-${location.zip}`;
    }
    return null;
  })),
  getPsxNotificationsCount: new DuckSelector(selectors => state => _get(selectors.getDuckState(state), 'psxNotificationsCount')),
  getMyCarsCount: new DuckSelector(selectors => state => _get(selectors.getDuckState(state), 'myCarsCount')),
  getRecentHistory: new DuckSelector(selectors => state => _get(selectors.getDuckState(state), 'history.inventory')),
  getIsUserEditProfile: new DuckSelector(selectors => state => _get(selectors.getDuckState(state), 'isUserEditProfile')),
  getShowToast: new DuckSelector(selectors => state => _get(selectors.getDuckState(state), 'showToast')),
  isHasChatPreviouslyVdpListing: new DuckSelector(selectors => createCachedSelector(selectors.getDuckState, (_, listingId) => listingId, (localState, listingId) => {
    const hasChatPreviouslyVdpListings = _get(localState, 'hasChatPreviouslyVdpListings', []);
    return hasChatPreviouslyVdpListings.includes(listingId);
  })({
    keySelector: (state, listingId) => listingId || 'default',
    cacheObject: new LruObjectCache({
      cacheSize: 100
    })
  })),
  getSelectedUserProfile: new DuckSelector(selectors => createCachedSelector(selectors.getLeadProfile, selectors.getUserProfile, selectors.getIsUserEditProfile, state => state?.auth || {}, function (leadProfile, userProfile, isUserEditProfile, auth) {
    if (leadProfile === void 0) {
      leadProfile = {};
    }
    if (userProfile === void 0) {
      userProfile = {};
    }
    if (isUserEditProfile === void 0) {
      isUserEditProfile = false;
    }
    if (auth === void 0) {
      auth = {};
    }
    let profile = leadProfile;
    const {
      isLoggedIn = false
    } = auth;
    if (isLoggedIn && !isUserEditProfile) {
      profile = ['firstName', 'lastName', 'email'].reduce((profileObj, key) => {
        profileObj[key] = userProfile[key];
        return profileObj;
      }, {});
      if (userProfile?.phone) {
        const cleanedPhone = ('' + userProfile.phone).replace(/\D/g, '');
        const phoneMatch = cleanedPhone.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (phoneMatch && phoneMatch.length > 3) {
          profile.phone = '(' + phoneMatch[1] + ') ' + phoneMatch[2] + '-' + phoneMatch[3];
        }
      }
    }
    return profile;
  })({
    keySelector: state => JSON.stringify(state?.auth) || 'default',
    cacheObject: new LruObjectCache({
      cacheSize: 100
    })
  }))
});